export default class TrackerContract{
  
  setUser(user) {
  }
  
  setAttributionData(payload) {
  }
  
  productImpressions(productImpressions) {
  }
  
  productClick(product, category) {
  }
  
  productView(product) {
  }
  
  addToCart(products) { /* Products or GiftCards */
  }
  
  removeFromCart(basketItem) {
  }
  
  checkout(step, basket) {
  }
  
  paymentOption(paymentSource, paymentAmount, isMultiPartPayment) {
  }
  
  purchase(transactionId, basket, affiliation) {
  }
  
  search(path, query) {
  }
  
  pageView(path) {
  }
  
  addPaymentInfo() {
  }
  
  signUp(method) {
  }
  
  login(method) {
  }

  viewItemList(menuItem){

  }
}